<template>
  <esg-base-chart>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="donut"
                ref="chart"
                :width=this.width
                :height=this.height
                v-show="!loading"
                :series="series"
                :options="chartOptions"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250'
    },
    legend: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          fontFamily: 'NanumGothic, serif'
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '70%',
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: '14px',
                  formatter: val => this.formatNumber(val, 0) + ' tCO2'
                },
                total: {
                  show: true,
                  label: new Date().getFullYear() + '년 배출량',
                  fontSize: '14px',
                  color: 'black',
                  formatter: chart => {
                    const total = chart.config.series.reduce((a, b) => a + b, 0)
                    return this.formatNumber(total, 0) + ' tCO2'
                  }
                },
              },
            },
          },
        },
        dataLabels: { enabled: false },
        tooltip: {
          y: {
            formatter: val => this.formatNumber(val, 2) + ' tCO2e'
          },
        },
        legend: {
          position: this.legend,
        },
        responsive: []
      },
    }
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let args = [{
          years: [year],
          scopes: [1, 2, 3],
          groupKeys: ['year', 'scope']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }
        let list = JSON.parse(response.data.data)[0].data

        this.series = list.map(row => row.values);
        this.chartOptions.labels = list.map(obj => `Scope ${obj.scope}`);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
  },
}
</script>
